import React from 'react';

class ResTable extends React.Component {

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    formatarValor(s) {

        if (s === null) return "";
        else if (s === 0) return "0,00";

        return this.moneyMask(s);

    }

    render() {
        return(
            <div>
                <table Class={ "resumo-anual-res-tbl" }>
                    <thead>
                        <tr>
                            <th>COD-CONTA</th>
                            <th>CONTA</th>
                            <th>01</th>
                            <th>02</th>
                            <th>03</th>
                            <th>04</th>
                            <th>05</th>
                            <th>06</th>
                            <th>07</th>
                            <th>08</th>
                            <th>09</th>
                            <th>10</th>
                            <th>11</th>
                            <th>12</th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.props.resumoAnual.tipo_contas.map((item, i) => {
                            return [
                                <tr key={ i } Style={ "background: " + item.cor + ";" }>
                                    <td><b>{ item.cod_conta }</b></td>
                                    <td><b>{ item.nome }</b></td>
                                    <td>{ this.formatarValor(item.soma_total[0]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[1]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[2]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[3]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[4]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[5]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[6]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[7]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[8]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[9]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[10]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[11]) }</td>
                                    <td>{ this.formatarValor(item.soma_total[12]) }</td>
                                </tr>,
                                item.contas.map((item2, j) => {
                                    return [
                                        <tr key={ j }>
                                            <td><b>{ item2.cod_conta }</b></td>
                                            <td><b>{ item2.conta }</b></td>
                                            <td>{ this.formatarValor(item2.total_mes[0]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[1]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[2]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[3]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[4]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[5]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[6]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[7]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[8]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[9]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[10]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[11]) }</td>
                                            <td>{ this.formatarValor(item2.total_mes[12]) }</td>
                                        </tr>
                                    ];
                                }),
                                <tr>
                                    <td><b></b></td>
                                    <td><b></b></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            ];
                        })}
                        <tr Style={ "background: #ccccff;" }>
                            <td><b></b></td>
                            <td><b>TOTAL SAÍDAS</b></td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_saidas[12]) }</td>
                        </tr>
                        <tr Style={ "background: #ccccff;" }>
                            <td><b></b></td>
                            <td><b>SALDO FINAL</b></td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.saldo_final[12]) }</td>
                        </tr>
                    </tbody>
                </table><br /><br />
                <table Class={ "resumo-anual-res-tbl" }>
                    <thead>
                        <tr>
                            <th></th>
                            <th>01</th>
                            <th>02</th>
                            <th>03</th>
                            <th>04</th>
                            <th>05</th>
                            <th>06</th>
                            <th>07</th>
                            <th>08</th>
                            <th>09</th>
                            <th>10</th>
                            <th>11</th>
                            <th>12</th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>TOTAL DE ENTRADAS</b></td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_entradas[12]) }</td>
                        </tr>
                        <tr>
                            <td><b>TOTAL DE INVESTIMENTO</b></td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_investimento[12]) }</td>
                        </tr>
                        <tr>
                            <td><b>TOTAL DE CORRENTES</b></td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[0]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[1]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[2]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[3]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[4]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[5]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[6]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[7]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[8]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[9]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[10]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[11]) }</td>
                            <td>{ this.formatarValor(this.props.resumoAnual.total_correntes[12]) }</td>
                        </tr>
                    </tbody>
                </table><br /><br />
            </div>
        );
    }

}

export default ResTable;

